export default __webpack_public_path__ + "static/media/data-safe-icon.7229b80c.svg";